import { useEffect, useState } from 'react'
import {
  MdOutlineAccountBox,
  MdOutlineArticle,
  MdOutlineDomain,
  MdOutlineGroup,
  MdOutlineGroups,
  MdOutlineHouse,
  MdOutlineList,
  MdOutlineSearch,
  MdOutlineShoppingCart
} from 'react-icons/md'
import { TbWorld } from 'react-icons/tb'
import { getMacrobolsaUser } from '../../../../apis-ssr/utils/macrobolsa/get-macrobolsa-user-status-client'
import { useRoles } from '../../../../auth/hooks/useRoles'
import { useSession } from '../../../../auth/hooks/useSession'
import { PATHS, ROUTES } from '../../../constants/routes'
import { IconHome } from '../assets/IconHome'

const STAGE = process.env.NEXT_PUBLIC_STAGE
const IS_PROD = STAGE === 'prod'

export interface OptionMenu {
  id: string
  icon?: React.ReactNode
  name: string
  mobileName?: string
  isShow: boolean
  isActive: boolean
  url?: string
  onClick: () => void
  subOptions?: OptionMenu[]
}

const ICON_CLASSNAME = 'min-h-[18px] min-w-[18px] md:text-primary'

export const useGetMenuOptions = () => {
  const { authUser } = useSession()
  const {
    isAssociation,
    isDeveloper,
    rolesExist,
    isAdminAgency,
    isIndependentAgent,
    roles
  } = useRoles()

  const { hasMacrobolsaNotAdvancedUser } = getMacrobolsaUser()

  const [pathname, setPathname] = useState('')
  const isActiveDeveloper = isDeveloper
    ? Boolean(authUser?.isSelectDevelop)
    : false

  const isNotAssociationOrDeveloper =
    rolesExist && !isAssociation && !isActiveDeveloper

  const menuOptions: OptionMenu[] = [
    {
      id: 'home',
      icon: <IconHome />,
      name: 'Inicio',
      isShow: Boolean(isNotAssociationOrDeveloper),
      isActive: pathname.startsWith(PATHS.HOME),
      url: ROUTES.HOME,
      onClick: () => (window.location.href = ROUTES.HOME)
    },
    {
      id: 'search',
      icon: <MdOutlineSearch className={ICON_CLASSNAME} />,
      name: 'Bolsa',
      isShow: Boolean(isNotAssociationOrDeveloper),
      isActive: pathname.startsWith(PATHS.SEARCH),
      url: ROUTES.SEARCH,
      onClick: () => (window.location.href = ROUTES.SEARCH)
    },
    {
      id: 'my-properties',
      icon: <MdOutlineHouse className={ICON_CLASSNAME} />,
      name: 'Propiedades',
      mobileName: 'Inventario',
      isShow: Boolean(isNotAssociationOrDeveloper),
      isActive: [
        PATHS.MY_PROPERTIES,
        PATHS.APPRAISALS,
        PATHS.MANAGE_PLATFORMS,
        PATHS.LISTS,
        PATHS.PROPERTY_PERFORMANCE
      ].some((path) => pathname.startsWith(path)),
      url: ROUTES.MY_PROPERTIES,
      onClick: () => (window.location.href = ROUTES.MY_PROPERTIES),
      subOptions: [
        {
          id: 'my-properties-inventory',
          name: 'Inventario',
          isShow: Boolean(isNotAssociationOrDeveloper),
          isActive: pathname.startsWith(PATHS.MY_PROPERTIES),
          url: ROUTES.MY_PROPERTIES,
          onClick: () => (window.location.href = ROUTES.MY_PROPERTIES)
        },
        {
          id: 'appraisals',
          name: 'Estimaciones',
          isActive: pathname.startsWith(PATHS.APPRAISALS),
          isShow: Boolean(isNotAssociationOrDeveloper),
          url: ROUTES.APPRAISALS(),
          onClick: () => (window.location.href = ROUTES.APPRAISALS())
        },
        {
          id: 'manage-platforms',
          name: 'Vinculaciones',
          isActive: pathname.startsWith(PATHS.MANAGE_PLATFORMS),
          isShow: Boolean(
            (isAdminAgency || isIndependentAgent) &&
              isNotAssociationOrDeveloper &&
              !hasMacrobolsaNotAdvancedUser
          ),
          url: ROUTES.MANAGE_PLATFORMS,
          onClick: () => (window.location.href = ROUTES.MANAGE_PLATFORMS)
        },
        {
          id: 'lists',
          icon: <MdOutlineList className={ICON_CLASSNAME} />,
          name: 'Listas compartidas',
          isShow: Boolean(
            isNotAssociationOrDeveloper && !hasMacrobolsaNotAdvancedUser
          ),
          isActive: pathname.startsWith(PATHS.LISTS),
          url: ROUTES.LISTS,
          onClick: () => (window.location.href = ROUTES.LISTS)
        },
        {
          id: 'property-performance',
          name: 'Desempeño',
          isActive: pathname.startsWith(PATHS.PROPERTY_PERFORMANCE),
          isShow: Boolean(
            isNotAssociationOrDeveloper && !hasMacrobolsaNotAdvancedUser
          ),
          url: ROUTES.PROPERTY_PERFORMANCE,
          onClick: () => (window.location.href = ROUTES.PROPERTY_PERFORMANCE)
        }
      ]
    },
    {
      id: 'lead-management',
      icon: <MdOutlineGroups className={ICON_CLASSNAME} />,
      name: 'Prospectos',
      mobileName: 'Prospectos',
      isShow: Boolean(isNotAssociationOrDeveloper),
      isActive: [PATHS.LEAD_MANAGEMENT].some((path) =>
        pathname.startsWith(path)
      ),
      url: ROUTES.LEAD_MANAGEMENT,
      onClick: () => {
        window.location.href = ROUTES.LEAD_MANAGEMENT
      },
      subOptions: [
        {
          id: 'tracking',
          name: 'Tablero de seguimiento',
          isShow: Boolean(isNotAssociationOrDeveloper),
          isActive: [PATHS.LEAD_MANAGEMENT].includes(pathname),
          url: ROUTES.LEAD_MANAGEMENT,
          onClick: () => (window.location.href = ROUTES.LEAD_MANAGEMENT)
        }
      ]

      /* subOptions: [
        {
          id: 'tracking',
          name: 'Seguimiento',
          isShow: Boolean(isNotAssociationOrDeveloper),
          isActive: [PATHS.LEAD_MANAGEMENT].includes(pathname),
          url: ROUTES.LEAD_MANAGEMENT,
          onClick: () => (window.location.href = ROUTES.LEAD_MANAGEMENT)
        },
        {
          id: 'contacts',
          name: 'Contactos',
          isShow: !IS_PROD && Boolean(!isNotAssociationOrDeveloper && !hasMacrobolsaNotAdvancedUser),
          isActive: [PATHS.LEAD_MANAGEMENT].includes(pathname),
          url: `${ROUTES.LEAD_MANAGEMENT}/contacts`,
          onClick: () =>
            (window.location.href = `${ROUTES.LEAD_MANAGEMENT}/contacts`)
        },
        {
          id: 'crm',
          icon: <MdOutlinePermContactCalendar className={ICON_CLASSNAME} />,
          name: 'CRM',
          isShow: Boolean(isNotAssociationOrDeveloper),
          isActive: [PATHS.CONTACTS].includes(pathname),
          url: ROUTES.CONTACTS,
          onClick: () => (window.location.href = ROUTES.CONTACTS)
        }
      ] */
    },
    {
      id: 'association-agencies',
      icon: <MdOutlineDomain className={ICON_CLASSNAME} />,
      name: 'Inmobiliarias',
      isActive: pathname.startsWith(PATHS.ASSOCIATION_AGENCIES),
      isShow: isAssociation,
      url: ROUTES.ASSOCIATION_AGENCIES,
      onClick: () => (window.location.href = ROUTES.ASSOCIATION_AGENCIES)
    },
    {
      id: 'association-properties',
      icon: <MdOutlineHouse className={ICON_CLASSNAME} />,
      name: 'Propiedades',
      isShow: isAssociation,
      isActive: pathname.startsWith(PATHS.ASSOCIATION_PROPERTIES),
      url: ROUTES.ASSOCIATION_PROPERTIES,
      onClick: () => (window.location.href = ROUTES.ASSOCIATION_PROPERTIES)
    },
    {
      id: 'association-brokers',
      icon: <MdOutlineGroup className={ICON_CLASSNAME} />,
      name: 'Asesores',
      isShow: isAssociation,
      isActive: pathname.startsWith(PATHS.ASSOCIATION_BROKERS),
      url: ROUTES.ASSOCIATION_BROKERS,
      onClick: () => (window.location.href = ROUTES.ASSOCIATION_BROKERS)
    },
    {
      id: 'my-agency',
      icon: <TbWorld className={ICON_CLASSNAME} />,
      name: 'Sitio web',
      isShow: Boolean(
        Boolean(
          !hasMacrobolsaNotAdvancedUser &&
            !isActiveDeveloper &&
            ((isNotAssociationOrDeveloper && !roles?.AGENCY_BROKER) ||
              roles?.AGENCY)
        ) || isAssociation
      ),
      isActive: pathname.startsWith(
        IS_PROD ? PATHS.AGENCY_SITE : PATHS.MINISITES_ONBOARDING
      ),
      url: IS_PROD ? ROUTES.AGENCY_SITE : ROUTES.MINISITES_ONBOARDING,
      onClick: () =>
        (window.location.href = IS_PROD
          ? ROUTES.AGENCY_SITE
          : ROUTES.MINISITES_ONBOARDING)

      /* subOptions: [
        {
          id: 'customize',
          name: 'Personalizar',
          isShow: Boolean(
            Boolean(
              !isActiveDeveloper &&
                ((isNotAssociationOrDeveloper && !roles?.AGENCY_BROKER) ||
                  roles?.AGENCY)
            ) || isAssociation
          ),
          isActive: [PATHS.AGENCY_SITE].includes(pathname),
          url: ROUTES.AGENCY_SITE,
          onClick: () => (window.location.href = ROUTES.AGENCY_SITE)
        },
        {
          id: 'site-web',
          name: 'Sitio web',
          isShow: Boolean(
            Boolean(
              !isActiveDeveloper &&
                ((isNotAssociationOrDeveloper && !roles?.AGENCY_BROKER) ||
                  roles?.AGENCY)
            ) || isAssociation
          ),
          isActive: [PATHS.AGENCY_SITE].includes(pathname),
          url: ROUTES.AGENCY_SITE,
          onClick: () => (window.location.href = ROUTES.AGENCY_SITE)
        },
        {
          id: 'partners',
          name: 'Colaboradores',
          isShow: Boolean(
            Boolean(
              !isActiveDeveloper &&
                ((isNotAssociationOrDeveloper && !roles?.AGENCY_BROKER) ||
                  roles?.AGENCY)
            ) || isAssociation
          ),
          isActive: [PATHS.AGENCY_SITE].includes(pathname),
          url: ROUTES.AGENCY_SITE,
          onClick: () => (window.location.href = ROUTES.AGENCY_SITE)
        }
      ] */
    },
    {
      id: 'association-reports',
      icon: <MdOutlineArticle className={ICON_CLASSNAME} />,
      name: 'Reportes',
      isShow: isAssociation,
      isActive: pathname.startsWith(PATHS.ASSOCIATION_REPORTS),
      url: ROUTES.ASSOCIATION_REPORTS,
      onClick: () => (window.location.href = ROUTES.ASSOCIATION_REPORTS)
    },
    {
      id: 'digital-card',
      icon: <MdOutlineAccountBox className={ICON_CLASSNAME} />,
      name: 'Tarjeta digital',
      isShow: Boolean(
        isNotAssociationOrDeveloper && !hasMacrobolsaNotAdvancedUser
      ),
      isActive: pathname.startsWith(PATHS.PROFILE),
      url: ROUTES.NEW_PROFILE,
      onClick: () => (window.location.href = ROUTES.NEW_PROFILE)
    },
    {
      id: 'shop',
      icon: <MdOutlineShoppingCart className={ICON_CLASSNAME} />,
      name: 'Tienda',
      isShow: !isActiveDeveloper,
      isActive: pathname.startsWith(PATHS.SHOP),
      url: ROUTES.SHOP,
      onClick: () => (window.location.href = ROUTES.SHOP)
    }
  ]

  const filteredMenuOptions = menuOptions
    ?.map((option) => {
      const filteredSubOptions = option?.subOptions?.filter(
        (subOption) => subOption?.isShow
      )

      return option?.subOptions
        ? {
            ...option,
            subOptions: filteredSubOptions
          }
        : option
    })
    ?.filter((option) => option?.isShow)

  useEffect(() => {
    setPathname(window.location.pathname)
  }, [])

  return { menuOptions: filteredMenuOptions, ICON_CLASSNAME }
}
